import React, { useState, useContext, useEffect, useRef } from 'react';
import { GridStatusBGColors } from '../../../../../constants/Enums';

import { AsNumber, useModal, ScrollbarSvg } from '@adserve/adserve-react-components';
import { SystemSettingsContext } from '../../../../../contexts/SystemSettingsContext';
import { AirtimePlanningContext } from '../../../../../contexts/AirtimePlanningContext';
import { GetCampaignPropertyStats } from '../../../../../services/CampaignsDataService';
import {
    DeletePropertySelectionById,
    GetPropertyTotals,
    LoadPropertyDealPrice
} from '../../../../../services/CampaignsDataService';
import TotalRow from './TotalRow';

import HeaderRow from './HeaderRow';
import SelectedPropertyRow from './SelectedPropertyRow';
import SelectedPropertyRowNew from './SelectedPropertyRowNew';
import AsLoading from '../../../../generic/adserve-react-components/AsLoading';
export const cellStyle = (h = 30, w = 30, bg = 'FFFFFF', bd = '1px solid #D7D7D7') => {
    return {
        boxSizing: 'border-box',
        height: h,
        width: w,
        border: bd,
        backgroundColor: bg
    };
};

const resultsTextStyle = {
    fontFamily: 'Roboto',
    color: '#414141',
    fontSize: 15,
    fontWeight: 500,
    marginTop: 3
};

const recommendedPriceStyle = {
    boxSizing: 'border-box',
    width: '100%',
    height: 30,
    outline: 'none',
    autoComplete: 'off',
    padding: '0 12px',
    fontSize: 15,
    letterSpacing: -0.3,
    fontWeight: 600,
    textAlign: 'center'
};

const tableStyle = {
    borderCollapse: 'collapse',
    borderColor: '#d7d7d7',
    color: '#545454',
    border: 1
};
const borderStyle = {
    border: '1px solid #D7D7D7'
};
const dataStyle = {
    boxSizing: 'border-box',
    padding: '0px 10px 0px 10px',
    color: '#414141',
    fontSize: 14,
    fontWeight: 500,
    textAlign: 'center',
    height: 40,
    ...borderStyle
};

const containerStyle = {
    display: 'block',
    width: 1808 + 80, // ASSP-6668 Add Reach % columns
    height: 342
};

const bodyCellStyle = {
    height: 40,
    border: '1px solid #D7D7D7',
    backgroundColor: '#FFFFFF',
    textAlign: 'right'
};

const SelectedPropertySelectionTable = ({
    readOnly,
    bookedReadOnly = false,
    campaign,
    updateCampaign,
    propertyCostingTypes = [],
    propertyTotals,
    setPropertyTotals,
    onDelete,
    recalcTotals,
    updateWinPrice,
    dealStationPrices,
    formatLaydown,
    currentCampaignVersionId
}) => {
    const { addMessage } = useModal();
    const { formatCurrency, dateFormat, formatNumber } = useContext(SystemSettingsContext);
    const maxRows = 5;
    const [highlightedRow, setHightlightedRow] = useState(-1);
    const g = campaign?.campaignGoal ? campaign.campaignGoal.find((s) => s.selected) : 0;
    const {
        propertyStats,
        setPropertyStats,
        isRunningPropertySelection,
        isCompletedPropertySelection,
        isPropertyStatsLoaded
    } = useContext(AirtimePlanningContext);
    const [lastDealVersionId, setLastDealVersionId] = useState();
    const scrollRef = useRef(null);
    const [scrollPx, setScrollPx] = useState(0);
    const handleScroll = (val) => {
        setScrollPx(val);
        scrollRef?.current?.scroll(0, val);
    };
    useEffect(() => {
        //        GetCampaignPropertyStats(campaign.id).then((data) => {
        //            setPropertyStats(data);
        //        });
    }, [campaign?.id]);

    const scrollbarStyle = {
        boxSizing: 'border-box',
        height: 201,
        width: 20,
        border: '1px solid #D7D7D7',
        backgroundColor: '#FFFFFF',
        position: 'absolute',
        marginTop: -301,
        marginLeft: 1788 + 80 // ASSP-6668 Add Reach % columns
    };

    const scrollbar = () => {
        return (
            <div style={scrollbarStyle}>
                {propertyStats?.length > 3 && (
                    <ScrollbarSvg
                        scrollPx={scrollPx}
                        onScroll={handleScroll}
                        gutterOffset={560}
                        maxVisibleLength={199}
                        scrollableLength={scrollRef?.current?.scrollHeight || 199}
                    />
                )}
            </div>
        );
    };

    const setCampaignBudget = (e) => {
        const g = campaign?.campaignGoal ? campaign?.campaignGoal.find((s) => s.selected) : 0;
        g.value = e.target.value;
        if (g.goal === 'budget') {
            updateCampaign('budget', e.target.value);
        } else {
            updateCampaign('campaignGoal', campaign.campaignGoal);
        }
    };
    useEffect(() => {
        setLastDealVersionId(campaign?.dealVersionId);
    }, [campaign?.dealVersionId, propertyStats]);

    const openProperty = (selectedProperty = {}, pmReadOnly = false) => {
        let campaignReturnPath = 'details';
        let campaignObjDetail = '&campaignDetail="{}"';
        if (
            !campaign?.id ||
            !campaign?.hasOwnProperty('id') ||
            campaign?.id === '00000000-0000-0000-0000-000000000000'
        ) {
            campaignReturnPath = 'create';
            const campaignVars = {
                id: '00000000-0000-0000-0000-000000000000',
                name: campaign.name,
                revenueTypeId: campaign.revenueTypeId,
                advertiserAccountId: campaign.advertiserAccountId,
                advertiserAccountName: campaign.advertiserAccountName,
                agencyAccountId: campaign.agencyAccountId,
                agencyAccountName: campaign.agencyAccountName,
                dealVersionId: campaign?.dealVersionId !== window.emptyGuid ? campaign?.dealVersionId : 0,
                demographicId: campaign.demographicId,
                demographicName: campaign.demographicName,
                productCategoryId: campaign.productCategoryId,
                productCategoryName: campaign.productCategoryName,
                budget: campaign.budget,
                commissionRate: campaign.commissionRate
            };
            campaignObjDetail = `&campaignDetail=${JSON.stringify(campaignVars)}`;
        }
        const selectedPropertyState = [];
        propertyStats?.forEach((sp) => {
            selectedPropertyState.push({
                entityType: sp?.isProperty ? 'property' : 'propertySelection',
                id: sp?.id
            });
        });

        window.open(
            `${window.origin}/property-manager/details/?propertySelectionId=${selectedProperty?.id}&propertyId=${
                selectedProperty?.sandPPropertyId
            }&selectedPropertyState=${JSON.stringify(selectedPropertyState)}&campaignId=${
                campaign?.id
            }&returnPath=${campaignReturnPath}${campaignObjDetail}&readonly=${pmReadOnly}&isBooked=${
                readOnly || bookedReadOnly
            }&source=campaign-manager`,
            '_self'
        );
    };

    const handleNameClick = (selectedProperty = {}) => {
        if (!(selectedProperty.id === window.emptyGuid)) {
            openProperty(selectedProperty, true);
        }
    };

    const deletePropertySelection = (selectedProperty) => {
        const idx = propertyStats.findIndex((a) => a === selectedProperty);
        campaign.modified = true;
        if (!selectedProperty?.id || selectedProperty?.id === window.emptyGuid) {
            const updatedSelectedProperties = [...propertyStats];
            updatedSelectedProperties.splice(idx, 1);
            setPropertyStats(updatedSelectedProperties);
            recalcTotals(updatedSelectedProperties);
        } else {
            DeletePropertySelectionById(selectedProperty?.id, campaign?.id).then((res) => {
                const updatedSelectedProperties = [...propertyStats];
                updatedSelectedProperties.splice(idx, 1);
                setPropertyStats(updatedSelectedProperties);
                recalcTotals(updatedSelectedProperties);
                onDelete(campaign?.id);
            });
        }
    };

    const deleteProperty = (selectedProperty) => {
        addMessage({
            message: window.translate(`Are you sure you want to delete ${selectedProperty.name}?`),
            buttons: [
                {
                    text: window.translate('No'),
                    style: { width: 87 },
                    callback: null
                },
                {
                    text: window.translate('Yes'),
                    style: { cursor: 'pointer' },
                    callback: () => deletePropertySelection(selectedProperty)
                }
            ]
        });
    };

    const updateProperties = (prop, originalProperty) => {
        campaign.modified = true;
        setPropertyStats([...propertyStats]);
    };

    useEffect(() => {
        propertyStats.map((a, b) => {
            a.index = b;
        });
        //   recalcTotals();
    }, [propertyStats]);

    const fillRows = () => {
        const rows = [];
        const pushedRows = {};

        const dpLength = propertyStats ? propertyStats.length : 0;
        for (let i = 0, len = dpLength; i < len; i++) {
            const alternateColour = i % 2 === 0 ? GridStatusBGColors.STRIPE : GridStatusBGColors.NOSTRIPE;
            rows.push(
                <SelectedPropertyRowNew
                    bodyCellStyle={bodyCellStyle}
                    alternateColour={alternateColour}
                    dataStyle={dataStyle}
                    openProperty={openProperty}
                    readOnly={readOnly}
                    bookedReadOnly={bookedReadOnly}
                    deleteProperty={deleteProperty}
                    handleNameClick={handleNameClick}
                    propertyCostingTypes={propertyCostingTypes}
                    selectedProperty={propertyStats[i]}
                    recalcTotals={recalcTotals}
                    campaign={campaign}
                    updateWinPrice={updateWinPrice}
                    dealStationPrices={dealStationPrices}
                    formatLaydown={formatLaydown}
                    currentCampaignVersionId={currentCampaignVersionId}
                    isRunning={isRunningPropertySelection(campaign, propertyStats[i])}
                    isCompleted={isCompletedPropertySelection(campaign, propertyStats[i])}
                ></SelectedPropertyRowNew>
            );
        }

        for (let i = 0, len = maxRows - dpLength; i < len; i++) {
            rows.push(
                <tr key={rows.length + 1}>
                    <td style={{ ...dataStyle, minWidth: 80, maxWidth: 80 }}>
                        <div style={{ display: 'flex' }}>
                            <div
                                style={{
                                    width: 40,
                                    height: '100%',
                                    borderRight: 'none',
                                    borderTop: 'none',
                                    paddingTop: 7
                                }}
                            />
                            <div
                                style={{
                                    width: 40,
                                    height: 32,
                                    borderLeft: '1px solid #D7D7D7',
                                    borderRight: 'none',
                                    borderTop: 'none',
                                    paddingTop: 7
                                }}
                            />
                        </div>
                    </td>
                    <td style={{ ...dataStyle, minWidth: 220, maxWidth: 220 }}>&nbsp;</td>
                    <td style={{ ...dataStyle, minWidth: 120, maxWidth: 120 }}>&nbsp;</td>
                    <td style={{ ...dataStyle, minWidth: 120, maxWidth: 120 }}>&nbsp;</td>
                    <td style={{ ...dataStyle, minWidth: 120, maxWidth: 120 }}>&nbsp;</td>
                    <td style={{ ...dataStyle, minWidth: 60, maxWidth: 60 }}>&nbsp;</td>
                    <td style={{ ...dataStyle, minWidth: 120, maxWidth: 120 }}>&nbsp;</td>
                    <td style={{ ...dataStyle, minWidth: 100, maxWidth: 100 }}>&nbsp;</td>
                    <td style={{ ...dataStyle, minWidth: 100, maxWidth: 100 }}>&nbsp;</td>
                    <td style={{ ...dataStyle, minWidth: 80, maxWidth: 80 }}>&nbsp;</td>
                    <td style={{ ...dataStyle, minWidth: 80, maxWidth: 80 }}>&nbsp;</td> {/* ASSP-6668 Reach % */}
                    <td style={{ ...dataStyle, minWidth: 80, maxWidth: 80 }}>&nbsp;</td>
                    <td style={{ ...dataStyle, minWidth: 70, maxWidth: 70 }}>&nbsp;</td>
                    <td style={{ ...dataStyle, minWidth: 110, maxWidth: 110 }}>&nbsp;</td>
                    <td style={{ ...dataStyle, minWidth: 140, maxWidth: 140 }}>&nbsp;</td>
                    <td style={{ ...dataStyle, minWidth: 140, maxWidth: 140 }}>&nbsp;</td>
                    <td style={{ ...dataStyle, minWidth: 130, maxWidth: 130 }}>&nbsp;</td>
                </tr>
            );
        }
        return rows;
    };

    return (
        <div style={containerStyle}>
        <div style={{color:'red',zIndex:999,height:30}}>{propertyStats?.filter(s=>s.dateChanged)?.length?window.translate("One or more properties have already started. All historic spots will be removed"):""}</div>
        <div style={{ position: 'relative', display: 'flex' }}>
                <div
                    style={{
                        position: 'absolute',
                        zIndex: 9999,
                        width: '100%',
                        minHeight: '100%',
                        display: isPropertyStatsLoaded ? 'none' : 'flex'
                    }}
                >
                    <div style={{ margin: 'auto' }}>
                        <AsLoading
                            style={{
                                height: '100%',
                                alignItems: 'center'
                            }}
                        />
                    </div>
                </div>
                <div>
                    <table
                        style={{
                            position: 'relative',
                            padding: '0 13px',
                            overflowWrap: 'anywhere',
                            ...tableStyle
                        }}
                    >
                        <HeaderRow></HeaderRow>
                    </table>
                    <div ref={scrollRef} style={{ width: '1378', height: 200, overflow: 'auto' }}>
                        <table
                            style={{
                                position: 'relative',
                                padding: '0 13px',
                                overflowWrap: 'anywhere',
                                ...tableStyle
                            }}
                        >
                            <tbody>{fillRows()}</tbody>
                        </table>
                    </div>
                    <table
                        style={{
                            position: 'relative',
                            padding: '0 13px',
                            overflowWrap: 'anywhere',

                            ...tableStyle
                        }}
                    >
                        <TotalRow
                            bodyCellStyle={bodyCellStyle}
                            dataStyle={dataStyle}
                            selectedProperties={propertyStats}
                            propertyTotals={propertyTotals}
                            setPropertyTotals={setPropertyTotals}
                        ></TotalRow>
                    </table>
                </div>
            </div>
            <div
                style={{
                    display: 'flex',
                    justifyContent: 'space-between',
                    marginTop: 18,
                    border: '1px solid #D7D7D7',
                    backgroundColor: '#F7F7F7'
                }}
            >
                <div
                    style={{
                        width: 330,
                        boxSizing: 'border-box',
                        paddingLeft: 20,
                        paddingTop: 10,
                        backgroundColor: '#F7F7F7',
                        borderRight: '1px solid #D7D7D7'
                    }}
                >
                    <span style={resultsTextStyle}>{window.translate('Additional Airtime Budget')}</span>
                </div>
                <div style={{ display: 'flex', width: 167 }}>
                    <AsNumber
                        id={'recommended-price'}
                        inputStyle={{
                            ...recommendedPriceStyle,
                            border: 0,
                            borderLeft: '1px solid #D7D7D7',
                            borderRadius: 0,
                            height: 40,
                            width: '100%'
                        }}
                        value={campaign?.budget}
                        onChange={setCampaignBudget}
                        disabled={readOnly}
                        disallowNegatives={true}
                        allowFloat={true}
                        formatNumber={formatCurrency}
                    />
                </div>
            </div>
        </div>
    );
};

export default SelectedPropertySelectionTable;
